
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/mad-id",
      function () {
        return require("private-next-pages/success-stories/mad-id/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/mad-id"])
      });
    }
  